export * from './baAppPicture.pipe';



// WEBPACK FOOTER //
// /app/src/app/theme/pipes/baAppPicture/index.ts